import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/constants/queryKeys';
import { CookiesConsent } from '@/analytics/types';
export function useCookiesConsent() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      queryKey: QUERY_KEYS.cookiesConsent(),
      queryFn: _temp2,
      retryOnMount: false,
      refetchInterval: _temp3
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return useQuery(t0);
}
function _temp3(data) {
  if (data) {
    return false;
  }
  return 300;
}
async function _temp2() {
  return new Promise(_temp);
}
function _temp(resolve, reject) {
  if (window.skippay?.cookie) {
    const cookieManager = window.skippay?.cookie;
    cookieManager?.hide();
    resolve(window.skippay?.cookie);
  } else {
    reject();
  }
}